// Extended invoice types with PO/GR matching for LineItemsPanel

export interface InvoiceDocument {
  id: string
  invoiceNumber: string
  invoiceDate: string
  dueDate: string
  receivedDate?: string
  currency: string
  supplier: string
  supplierABN?: string
  poNumber?: string
  matchingType?: '2-way' | '3-way' | 'non-po'
  subtotal: number
  taxAmt: number
  total: number
  notes?: string
  attachments?: string[]
  lineItems: LineItem[]
  imageUrl?: string
}

export interface LineItem {
  id: string
  itemCode: string
  description: string
  quantity: number
  unitPrice: number
  subtotal: number
  taxCode: string
  taxAmt: number
  total: number
  type: 'CR' | 'DR' | string
  glCode?: string
  notes?: string
  poMatch?: PurchaseOrderMatch
  grMatch?: GoodsReceiptMatch
}

export interface PurchaseOrderMatch {
  poNumber: string
  poLineNumber: number
  poLineDescription: string
  poUnitPrice: number
  poQuantity: number
  matchedQuantity: number
  remainingQuantity: number
  matchedAmount: number
  glCode: string
}

export interface GoodsReceiptMatch {
  grNumber: string
  grDate: string
  grQuantity: number
}

// Tax Code types for Australian GST
export interface TaxCode {
  code: string
  meaning: string
  gstRate: string
  basEquivalent: string
  basTreatment: string
}

export const TAX_CODES: TaxCode[] = [
  {
    code: 'I',
    meaning: 'Input Taxed — Standard GST',
    gstRate: '10%',
    basEquivalent: 'G11 — Non-capital acquisitions',
    basTreatment: 'GST amount claimable as Input Tax Credit (ITC) at label 1B',
  },
  {
    code: 'E',
    meaning: 'GST-Free (Exempt)',
    gstRate: '0%',
    basEquivalent: 'G14 — Acquisitions with no GST in the price',
    basTreatment: 'No GST charged; reported at G14. No ITC claim.',
  },
  {
    code: 'Z',
    meaning: 'Zero Rated Export',
    gstRate: '0%',
    basEquivalent: 'G15 — Estimated purchases for private use',
    basTreatment: 'Zero-rated supply; no GST payable or claimable.',
  },
  {
    code: 'R',
    meaning: 'Reduced Input Tax Credit',
    gstRate: '10%',
    basEquivalent: 'G11 — Non-capital acquisitions (reduced credit)',
    basTreatment: 'Only 75% of GST claimable as ITC (e.g. financial supplies).',
  },
  {
    code: 'N',
    meaning: 'Not Reportable / No ABN Withholding',
    gstRate: '0%',
    basEquivalent: 'Not reported on BAS',
    basTreatment: 'Outside GST system. May require PAYG withholding if no ABN.',
  },
]

export interface Invoice {
  id: string
  vendor: string
  documentNo?: string
  documentType: string
  status: string
  team: string
  amount: string
  receivedDate: string
  documentDate: string
  dueDate?: string
  poNo?: string
  tag?: string
  timestamp: string
  lockedBy?: string
}
